import moment from "moment-timezone";
import secureLocalStorage from "react-secure-storage";

export const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const storeValue = (key, value) => {
  secureLocalStorage.setItem(key, value);
};

export const getValue = (key) => {
  return secureLocalStorage.getItem(key);
};

// Convert plain digit numbers to +<country> <rest>
// Rules (simple):
// - If starts with "1" and length is 11 => +1 <remaining 10 digits>
// - If starts with "91" and length is 12 => +91 <remaining 10 digits>
// - Otherwise returns "N/A" (adjust as needed)
export const formatPhoneNumber = (phoneNumber) => {
  if (phoneNumber === null || phoneNumber === undefined) return "N/A";

  const digits = String(phoneNumber).replace(/\D/g, "");

  // US (1 + 10 digits)
  if (digits.length === 11 && digits.startsWith("1")) {
    return `+1 ${digits.slice(1)}`;
  }

  // India (91 + 10 digits)
  if (digits.length === 12 && digits.startsWith("91")) {
    return `+91 ${digits.slice(2)}`;
  }

  return "N/A";
};

export const formatDateInTimezone = (date) => {
  return moment(date).tz("Asia/Kolkata").format("DD - MM - YYYY");
};

export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const calculateAge = (dobString) => {
  const dob = new Date(dobString);
  const today = new Date();

  let age = today.getFullYear() - dob.getFullYear();
  const monthDifference = today.getMonth() - dob.getMonth();

  // Check if the birthday has occurred yet this year; if not, subtract one year from the age.
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < dob.getDate())
  ) {
    age--;
  }

  return age;
};
